// extracted by mini-css-extract-plugin
export default {"root":"quoted-tweet-body_root__rG35w"};